module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/images/light_left.9a812f4f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/images/light_left.png
// module id = 3479
// module chunks = 11